"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConfig = void 0;
exports._setConfigForTesting = _setConfigForTesting;
exports.getConfig = getConfig;
exports.loadRuntimeConfig = loadRuntimeConfig;
let state = {
    status: 'loading',
};
// Función para uso interno y testing
function _setConfigForTesting(config) {
    state = {
        status: 'ready',
        config: {
            ...config,
            CONFIG_SOURCE: 'test',
        },
    };
}
function getConfig() {
    if (state.status !== 'ready') {
        throw new Error(state.status === 'loading'
            ? 'Configuración no cargada aún'
            : 'Error cargando configuración');
    }
    return state.config;
}
async function loadRuntimeConfig() {
    try {
        const response = await fetch('/config.json');
        if (!response.ok)
            throw new Error(`HTTP ${response.status}`);
        const loadedConfig = await response.json();
        if (!loadedConfig.API_URL) {
            throw new Error('API_URL no definido en config.json');
        }
        state = {
            status: 'ready',
            config: {
                API_URL: loadedConfig.API_URL,
                VERSION: loadedConfig.VERSION || '1.0.0',
                ENV: loadedConfig.ENV || 'production',
                DB_TOKEN: loadedConfig.DB_TOKEN,
                KEYCLOAK_URL: loadedConfig.KEYCLOAK_URL,
                KEYCLOAK_REALM: loadedConfig.KEYCLOAK_REALM,
                KEYCLOAK_CLIENT_ID: loadedConfig.KEYCLOAK_CLIENT_ID,
                WEB_URL: loadedConfig.WEB_URL,
                AUTH_URL: loadedConfig.AUTH_URL,
                GROWTHBOOK_CLIENT_KEY: loadedConfig.GROWTHBOOK_CLIENT_KEY,
            },
        };
    }
    catch (error) {
        state = {
            status: 'error',
            error: error instanceof Error ? error : new Error(String(error)),
        };
        throw error;
    }
}
exports.setConfig = _setConfigForTesting;
